<template>
  <v-container>
    <PageHeader :title="name" />
    <v-layout wrap>
      <v-flex md6 xs12 class="pr-2">
        <guidelines-detail-form :currentGuideline="currentGuideline" :actionName="name" :isAddpageForm="isAddpageForm" :tenantData="tenantData" v-if="isTenantAdmin" />
      </v-flex>
      <v-flex md6 xs12 class="pl-2">
        <guidelines-detail-tenant :currentGuideline="currentGuideline" :name="name" :isAddpageForm="isAddpageForm" v-if="!isAddpageForm && isSystemAdmin" />
      </v-flex>
      <guidelines-detail-standards class="mt-2" :currentGuideline="currentGuideline" :name="name" :isAddpageForm="isAddpageForm" v-if="!isAddpageForm && isSystemAdmin" />
    </v-layout>
  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import { createNamespacedHelpers } from 'vuex'
  import GuidelinesDetailForm from './GuidelinesDetailForm'
  import GuidelinesDetailTenant from './GuidelinesDetailTenant'
  import GuidelinesDetailStandards from './GuidelinesDetailStandards'
  import { AddGuidelineActionName } from '@/components/mixins/GuidelinesManageUtil'

  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const app = createNamespacedHelpers('app')

  export default {
    components: {
      'guidelines-detail-form': GuidelinesDetailForm,
      'guidelines-detail-tenant': GuidelinesDetailTenant,
      'guidelines-detail-standards': GuidelinesDetailStandards,
      PageHeader,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      tenantData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        isAddpageForm: true,
        currentGuidelineName: this.$route.params.name,
        guidelineId: null,
      }
    },
    mounted() {
      this.fetchData()
    },
    computed: {
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines']),
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['isTenantAdmin', 'isSystemAdmin']),
      ...app.mapGetters(['loadingHasFinish']),
      currentGuideline() {
        if (!this.isAddpageForm) {
          if (this.guidelineId == null) {
            let matched = this.Guidelines.find(
              x => x.GuidelineName == this.currentGuidelineName
            )
            this.guidelineId = matched.Id
            return matched
          } else {
            return this.Guidelines.find(
              x => x.Id == this.guidelineId
            )
          }
        } else {
          return null
        }
      },
    },
    watch: {
      loadingHasFinish() {
        this.fetchData()
      },
    },
    methods: {
      fetchData() {
        if (!this.loadingHasFinish) {
          return
        }
        var isGuidelineExist = this.Guidelines.find(
          x => x.GuidelineName == this.currentGuidelineName
        )
        if (!isGuidelineExist) {
          if (this.currentGuidelineName == AddGuidelineActionName) {
            this.isAddpageForm = true
          } else {
            this.$router.push({
              name: '404',
              params: {
                badURL: this.$route.fullPath,
                title: 'Guideline Not Found',
              },
            })
          }
        } else {
          this.isAddpageForm = false
        }
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>